// extracted by mini-css-extract-plugin
export default {"list":"info-list_list__Z50LZ","item":"info-list_item__CPKVk","quantityWrapper":"info-list_quantityWrapper__IIFLC","quantity":"info-list_quantity__n-L92"};